<div>
    <p>Favor de leer y aceptar el "Aviso de privacidad"</p>
</div>